import React from "react";
import moment from "moment";

export default class RanksAndPoints extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab:
        this.props.activeTab ||
        (this.props.point_tracking_enabled ? "points" : "history"),
    };

    this.onChangeTab = this.onChangeTab.bind(this);
    this.resizeNames = this.resizeNames.bind(this);
  }

  // componentDidUpdate() {
  // 	var self = this;

  // 	$(window).on('resize.ranks-and-points', function () { self.resizeNames(); }).trigger('resize.ranks-and-points');
  // }

  render() {
    if (this.props.point_tracking_enabled) {
      return (
        <div className="ranks-and-points" ref="root">
          <ul className="nav nav-tabs">
            <li className={this.state.activeTab == "points" ? "active" : ""}>
              <a href="#" data-name="points" onClick={this.onChangeTab}>
                About
              </a>
            </li>
            <li className={this.state.activeTab == "history" ? "active" : ""}>
              <a href="#" data-name="history" onClick={this.onChangeTab}>
                History
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div
              className={
                "tab-pane " + (this.state.activeTab == "points" ? "active" : "")
              }
            >
              {this.renderAbout()}
            </div>
            <div
              className={
                "tab-pane " +
                (this.state.activeTab == "history" ? "active" : "")
              }
            >
              {this.renderHistory()}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="ranks-and-points" ref="root">
          <ul className="nav nav-tabs">
            <li className={this.state.activeTab == "history" ? "active" : ""}>
              <a href="#" data-name="history" onClick={this.onChangeTab}>
                History
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div
              className={
                "tab-pane " +
                (this.state.activeTab == "history" ? "active" : "")
              }
            >
              {this.renderHistory()}
            </div>
          </div>
        </div>
      );
    }
  }

  renderAbout() {
    var levels = this.props.points_levels.map(function (points_level) {
      //console.log('points_level', points_level)
      if (points_level) {
        return (
          <div key={points_level.id} className="points-level">
            <div className="row">
              <div className="col-2">
                <img
                  src={points_level.image_url}
                  style={{ width: "100%", height: "auto" }}
                />
              </div>
              <div className="col-10">
                <div className="name">
                  <span className="level">Level </span>
                  <span className="level-name">{points_level.name}</span>
                  <span className="level" style={{ marginLeft: 1 }}>
                    :{" "}
                  </span>
                  <span className="points-range">
                    {points_level.number_of_points_range_start} -{" "}
                    {points_level.number_of_points_range_end}{" "}
                  </span>
                  <span className="points-label">POINTS</span>
                </div>
                <div className="description">{points_level.description}</div>
              </div>
            </div>
          </div>
        );
      }
    });
    return (
      <div className="points-levels">
        <h4>How To Earn Points</h4>
        <p>
          You earn points by reading articles and passing{" "}
          {I18n.t("quizzes").toLowerCase()}. Every article you read will earn
          you {this.props.points_for_article}{" "}
          {this.props.points_for_article > 1 ? "points" : "point"} and every{" "}
          {I18n.t("quiz").toLowerCase()} you pass will earn you{" "}
          {this.props.points_for_passing_quiz}{" "}
          {this.props.points_for_passing_quiz > 1 ? "points" : "point"}. A
          passing {I18n.t("quiz_score").toLowerCase()} is{" "}
          {this.props.quiz_score_to_pass}% or higher.
        </p>
        {levels}
      </div>
    );
  }

  renderHistory() {
    var self = this;
    // console.log('renderHistory', this.props.point_tracking_enabled);
    var history = this.props.course_history.map(function (history) {
      //console.log('history', history);
      return (
        <tr
          key={history.course_id}
          className={"course-history" + (history.number ? " has-number" : "")}
        >
          <td>
            <a href={history.path} className="image">
              <img
                src={history.image_src}
                style={{ width: "100%", height: "auto" }}
              />
              {history.number ? (
                <span className="number">{history.number}</span>
              ) : null}
            </a>
          </td>

          <td style={{ width: "50%" }}>
            <div className="name ref-name">
              <a href={history.path}>{history.name}</a>
            </div>
            <div className="progress-wrapper">
              <span className="score">
                {Math.floor(history.course_progress * 100)}%
              </span>{" "}
              Progress
            </div>
            <div
              className="quiz-score"
              style={{
                display: !history.last_passed_quiz_score ? "none" : "block",
              }}
            >
              <span className="score">
                {Math.floor(history.last_passed_quiz_score * 100)}%
              </span>{" "}
              {I18n.t("quiz_score")}
            </div>
          </td>

          <td>
            <div className="name resize-name" style={{ visibility: "hidden" }}>
              {history.name}
            </div>
            <div className="date">
              {history.last_article_viewed_date
                ? moment(history.last_article_viewed_date).format("MM/DD/YYYY")
                : " "}
            </div>
            <div
              className="date"
              style={{
                display: !history.last_passed_quiz_score ? "none" : "block",
              }}
            >
              {history.last_passed_quiz_date
                ? moment(history.last_passed_quiz_date).format("MM/DD/YYYY")
                : " "}
            </div>
          </td>

          {self.props.point_tracking_enabled ? (
            <td>
              <div className="points">
                <div
                  className="name resize-name"
                  style={{ visibility: "hidden" }}
                >
                  {history.name}
                </div>
                <div className="total-points">{history.total_points}</div>
                <div className="articles-viewed-points">
                  {history.articles_viewed_points}
                </div>
                <div
                  className="quizzes-passed-points"
                  style={{
                    display: !history.last_passed_quiz_score ? "none" : "block",
                  }}
                >
                  {history.quizzes_passed_points}
                </div>
              </div>
            </td>
          ) : null}
        </tr>
      );
    });

    return (
      <div className="course-history-wrapper">
        <table>
          <thead>
            <tr>
              <th
                colSpan="2"
                className="history-header"
                style={{ textAlign: "left" }}
              >
                {I18n.t("course")}
              </th>
              <th className="history-header">Date</th>
              {this.props.point_tracking_enabled ? (
                <th className="history-header" style={{ textAlign: "right" }}>
                  Points
                </th>
              ) : null}
            </tr>
          </thead>
          <tbody>{history}</tbody>
        </table>

        {this.props.point_tracking_enabled ? (
          <div className="totals-wrapper">
            <div className="row">
              <div className="col-12" style={{ paddingLeft: 15 }}>
                <h3>Totals</h3>
                <div className="totals">
                  <div className="pull-left">
                    <span className="active-courses">
                      <strong>{this.props.course_history.length}</strong>{" "}
                      {I18n.t("active_courses")}
                    </span>
                  </div>

                  <div className="pull-right">
                    <span className="points">
                      <strong className="large">
                        {this.props.user_total_points}
                      </strong>{" "}
                      points
                    </span>
                    {this.props.points_reset_date ? (
                      <div
                        style={{
                          fontSize: "10px",
                          textTransform: "uppercase",
                          letterSpacing: "1px",
                          fontWeight: "bold",
                          color: "#777",
                        }}
                      >
                        {I18n.t("since")} {this.props.points_reset_date}
                      </div>
                    ) : null}
                    <div>
                      <span className="level">
                        Level {this.props.user_current_points_level.name}
                      </span>
                    </div>
                  </div>
                  <div className="clearfix">&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  resizeNames() {
    $(this.refs.root)
      .find(".course-history")
      .each(function () {
        var $this = $(this);
        var $ref_name = $this.find(".ref-name");

        $ref_name.width($this.find(".col-2").first().width() * 4);
        $this.find(".resize-name").height($ref_name.height());
      });
  }

  onChangeTab(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ activeTab: e.target.dataset.name });
  }
}
